export default __webpack_public_path__ + "static/media/discord.8076f09a.svg";